import { render } from "./SolarSimpleTariffTable.vue?vue&type=template&id=6c066512"
import script from "./SolarSimpleTariffTable.vue?vue&type=script&lang=js"
export * from "./SolarSimpleTariffTable.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__